const DECIMAL_PLACES = 2;

const Score = ({ score }: { score?: number }) => {
    if (!score) {
        return;
    }
    return (
        <div className="text-right text-xs text-gray-6">
            Score: {score.toFixed(DECIMAL_PLACES)}
        </div>
    );
};

export default Score;
